/**
 * Namespace és kulcs concatenálása.
 * @param ns  - A namespace.
 * @param key - A kulcs.
 */
export default function getNamespacedKey<TKey extends string> (ns: string, key: TKey): string {
  return ns.length ? `${ ns }.${ key }` : key
}
